import { render, staticRenderFns } from "./BalanceIndex.vue?vue&type=template&id=6bf24384&scoped=true"
import script from "./BalanceIndex.vue?vue&type=script&lang=js"
export * from "./BalanceIndex.vue?vue&type=script&lang=js"
import style0 from "./BalanceIndex.vue?vue&type=style&index=0&id=6bf24384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf24384",
  null
  
)

export default component.exports